/**
 * @ngdoc component
 * @name westBerkshireEvents.addressLookup:wbAddressLookup
 * 
 * @description 
 * Makes a call to West Berkshires API to grab the relevant addresses
 */

import lookupTemplate from './address_lookup.template.html';

angular.module('westBerkshireEvents.addressLookup').component('wbAddressLookup', {
    scope: {},
    templateUrl: lookupTemplate.id,
    controllerAs: '$addressLookupCtrl',
    bindings: {
        client: '<',
        clientdetails: '<'
    },
    controller: wbAddressLookupController
});

function wbAddressLookupController($http, $scope, LoadingService, $element, WbAddressLookupService) {
    var self = this;
    var addressInput = ($element.find('.address-div'));
    addressInput.hide();

    const loader = LoadingService.$loader($scope);

    self.buttonClick = function () {
        loader.notLoaded();

        WbAddressLookupService.lookupPostcode(self.client.postcode).then(results => {
            self.response = "";
            self.addresses = results;
            for (var index = 0; index < self.addresses.length; index++) {
                var arrElement;
                var element = self.addresses[index];

                let addressParts = [];

                if (element.property) {
                    addressParts.push(element.property);
                }
                if (element.subbuilding) {
                    addressParts.push(element.subbuilding);
                }
                addressParts.push(element.street);
                addressParts.push(element.town);
                addressParts.push(element.area);
                addressParts.push(element.postcode);

                element.displayText = addressParts.join(', ');
                addressInput.show();
            }
            loader.setLoaded();
        }, err => {
            self.response = err;
            loader.setLoaded();
            addressInput.hide();
        });
    };

    // when user selects an address from the select input, it populates the address fields accordingly
    self.onChange = function () {

        if (self.selectedAddress.property) {
            self.client.address1 = self.selectedAddress.property;
            self.client.address2 = self.selectedAddress.street;
        } else {
            self.client.address1 = self.selectedAddress.street;
            self.client.address2 = "";
        }
        self.client.address4 = self.selectedAddress.town;
        self.client.address5 = self.selectedAddress.area;
        self.client.postcode = self.selectedAddress.postcode;

        // filters through the available client questions and if the question is 'UPRN'
        // then bind the uprn from the respone to the question input field
        for (var index = 0; index < self.clientdetails.questions.length; index++) {
            var question = self.clientdetails.questions[index];
            if ((new RegExp('UPRN')).test(question.name)) {
                question.answer = self.selectedAddress.uprn;
            }
        }
    };
}




// WEBPACK FOOTER //
// ../src/public/javascripts/address-lookup/address_lookup.component.js